import { render } from "./StageDoForward.vue?vue&type=template&id=17bd5dab&scoped=true"
import script from "./StageDoForward.vue?vue&type=script&lang=js"
export * from "./StageDoForward.vue?vue&type=script&lang=js"

import "./StageDoForward.vue?vue&type=style&index=0&id=17bd5dab&lang=scss&scoped=true"

import exportComponent from "/data/projects/private_futurelab/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-17bd5dab"]])

export default __exports__